<div class="prepaid-modal-backdrop" *ngIf="modal.state()" (click)="modal.close()">
  <div class="prepaid-modal f-Inter" role="dialog" aria-modal="true" aria-labelledby="prepaid-modal-title"
    (click)="$event.stopPropagation()">
    <div class="prepaid-modal__content">
      <img class="prepaid-modal__image" src="https://assets.denefits.com/email/template/paymentCardError.png" alt="Prepaid card">
      <div class="prepaid-modal__text">
        <h4 id="prepaid-modal-title">Prepaid Cards Not Accepted</h4>
        <p>{{ text() }}</p>
      </div>
    </div>
    <div class="prepaid-modal__actions">
      <button type="button" class="prepaid-modal__primary" (click)="modal.useDifferentCard()">Use a Different Card</button>
      <button type="button" class="prepaid-modal__cancel" (click)="modal.close()">Cancel</button>
    </div>
  </div>
</div>
